import { renderAuthStyle } from "./style.js";

/** @returns {string} */
function renderAuthForm() {
  return `
    <form data-role="auth-form" novalidate class="login-container" aria-busy="false">
      <fieldset class="hauth-fieldset">
        <div class="form-group">
          <div class="col-md logo-row">
            <slot name="logo">
              <img width="120" height="76" alt="logo" class="logo" data-role="logo" />
            </slot>
          </div>
        </div>

        <div class="form-group">
          <div class="col-md">
            <input
              id="UserName"
              data-input="username"
              name="username"
              required
              autocomplete="off"
              class="form-control"
              placeholder="Username"
            />
          </div>
        </div>

        <div class="form-group">
          <div class="col-md">
            <input
              id="Password"
              data-input="password"
              name="password"
              type="password"
              required
              autocomplete="off"
              class="form-control"
              placeholder="Password"
            />
          </div>
        </div>

        <div class="form-group">
          <div class="col-md mobile-invisible">
            <a id="forgotPasswordLink" class="text-nowrap login-link" href=""><slot name="forgot-password-label">Forgot Username or Password?</slot></a>
          </div>
        </div>

        <div class="form-group">
          <div class="col-md">
            <button id="loginButton" type="submit" class="btn btn-primary" disabled><slot name="submit-label">Log in</slot></button>
            <div class="text-danger" data-role="form-error" role="alert" aria-live="assertive" hidden></div>
          </div>
        </div>

        <div class="form-group">
          <div class="col-md mobile-invisible">
            <span data-role="register-prompt"><slot name="register-prompt-label">Not a member yet?</slot></span>
            <a class="text-nowrap login-link" data-role="register-link" href=""><slot name="register-label">Create new account</slot></a>
          </div>

          <div class="col-md login-footer">
            <p class="footer-text">
              <a target="_blank" rel="noopener noreferrer" href="" class="copyright" data-role="copyright-link"><slot name="copyright-label">©2026 Hygiena, LLC</slot></a>
            </p>
            <div>
              <slot name="hygiena-logo">
                <img width="120" height="32" alt="Hygiena" class="hygiena-logo" data-role="hygiena-logo" />
              </slot>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  `;
}

/** @returns {string} */
export function renderAuthMarkup() {
  const styles = renderAuthStyle();

  return `
    <style>
      ${styles}
    </style>

    <section class="hauth-root">
      <dialog class="hauth-popup-dialog" data-role="popup-dialog" aria-label="Log in" hidden>
        <div class="hauth-popup-window">
          <div class="hauth-popup-header">
            <button type="button" class="hauth-popup-close" data-role="popup-close-button" aria-label="Close">
              <slot name="close-label">×</slot>
            </button>
          </div>
          ${renderAuthForm()}
        </div>
      </dialog>
    </section>
  `;
}
